import React, { useState } from "react";
import config from "../config";

function formatDate(dateStr) {
  const d = new Date(dateStr);
  return d.toLocaleDateString("en-GB", { day:"2-digit", month:"short", year:"numeric" });
}

function StatusBadge({ days, noExpiry, isLeaver }) {
  if (isLeaver) return <span style={{ display:"inline-flex", alignItems:"center", gap:"5px", padding:"3px 9px", borderRadius:"20px", fontSize:"10px", fontWeight:700, background:"#f5e8ea", color:"#82162d" }}>Leaver</span>;
  if (noExpiry) return <span style={{ display:"inline-flex", alignItems:"center", gap:"5px", padding:"3px 9px", borderRadius:"20px", fontSize:"10px", fontWeight:700, background:"#e8ede7", color:"#3a4838" }}>No expiry</span>;
  if (days <= 0) return <span style={{ display:"inline-flex", alignItems:"center", gap:"5px", padding:"3px 9px", borderRadius:"20px", fontSize:"10px", fontWeight:700, background:"#f5e8ea", color:"#82162d" }}><span style={{ width:"5px", height:"5px", borderRadius:"50%", background:"#82162d", display:"inline-block" }}></span>Expired today</span>;
  if (days <= 7) return <span style={{ display:"inline-flex", alignItems:"center", gap:"5px", padding:"3px 9px", borderRadius:"20px", fontSize:"10px", fontWeight:700, background:"#f5e8ea", color:"#82162d" }}><span style={{ width:"5px", height:"5px", borderRadius:"50%", background:"#82162d", display:"inline-block" }}></span>{days} days</span>;
  if (days <= 30) return <span style={{ display:"inline-flex", alignItems:"center", gap:"5px", padding:"3px 9px", borderRadius:"20px", fontSize:"10px", fontWeight:700, background:"#fdf3e3", color:"#7a4420" }}><span style={{ width:"5px", height:"5px", borderRadius:"50%", background:"#cc8943", display:"inline-block" }}></span>{days} days</span>;
  return <span style={{ display:"inline-flex", alignItems:"center", gap:"5px", padding:"3px 9px", borderRadius:"20px", fontSize:"10px", fontWeight:700, background:"#e8ede7", color:"#3a4838" }}><span style={{ width:"5px", height:"5px", borderRadius:"50%", background:"#677a64", display:"inline-block" }}></span>{days} days</span>;
}

function EndDateCell({ days, dateStr, noExpiry }) {
  if (noExpiry) return <span style={{ color:"#b0adc8" }}>—</span>;
  const color = days <= 0 ? "#82162d" : days <= 30 ? "#cc8943" : "#18073a";
  return <span style={{ fontWeight:600, color }}>{formatDate(dateStr)}</span>;
}

function ContractorRow({ contractor, onAmend, onTerminate, onAmendDetails, pendingTicket, isLeaver }) {
  const [hovered, setHovered] = useState(false);

  const pending = pendingTicket || {};
  const fsBase = `https://${config.freshserviceDomain}/helpdesk/tickets/`;

  const pendingStyle = { padding:"5px 11px", fontSize:"11px", fontWeight:600, borderRadius:"5px", background:"#faeeda", color:"#854F0B", textDecoration:"none", display:"inline-flex", alignItems:"center", gap:"4px" };
  const btnBase = { padding:"5px 11px", fontSize:"11px", fontWeight:600, border:"none", borderRadius:"5px", cursor:"pointer", fontFamily:"Montserrat, sans-serif" };

  return (
    <tr
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{ background: hovered ? "#fafaf8" : "#fff" }}
    >
      <td style={{ padding:"13px 16px", borderBottom:"0.5px solid #f5f5f3", fontSize:"12px" }}>
        <div style={{ fontWeight:600, fontSize:"13px", color:"#18073a" }}>{contractor.name}</div>
      </td>
      <td style={{ padding:"13px 16px", borderBottom:"0.5px solid #f5f5f3", fontSize:"11px", color:"#79749c" }}>{contractor.email}</td>
      <td style={{ padding:"13px 16px", borderBottom:"0.5px solid #f5f5f3", fontSize:"12px" }}>{contractor.department}</td>
      <td style={{ padding:"13px 16px", borderBottom:"0.5px solid #f5f5f3", fontSize:"12px" }}>{contractor.jobTitle}</td>
      <td style={{ padding:"13px 16px", borderBottom:"0.5px solid #f5f5f3", fontSize:"12px" }}>{contractor.company || "—"}</td>

      {/* Amend details column */}
      <td style={{ padding:"13px 16px", borderBottom:"0.5px solid #f5f5f3" }}>
        <div style={{ opacity: hovered ? 1 : 0, transition:"opacity 0.15s" }}>
          {!isLeaver && (
            pending.amendDetails
              ? <a href={`${fsBase}${pending.amendDetails.replace('SR-','')}`} target="_blank" rel="noreferrer" style={pendingStyle}>⏳ {pending.amendDetails} pending</a>
              : <button onClick={() => onAmendDetails(contractor)} style={{ ...btnBase, background:"#eaf0f5", color:"#0f4c75" }}>Amend details</button>
          )}
        </div>
      </td>

      <td style={{ padding:"13px 16px", borderBottom:"0.5px solid #f5f5f3", fontSize:"11px", color:"#b0adc8" }}>{contractor.created}</td>
      <td style={{ padding:"13px 16px", borderBottom:"0.5px solid #f5f5f3" }}><EndDateCell days={contractor.daysRemaining} dateStr={contractor.endDate} noExpiry={contractor.noExpiry} /></td>
      <td style={{ padding:"13px 16px", borderBottom:"0.5px solid #f5f5f3" }}><StatusBadge days={contractor.daysRemaining} noExpiry={contractor.noExpiry} isLeaver={contractor.isLeaver} /></td>

      {/* Actions column */}
      <td style={{ padding:"13px 16px", borderBottom:"0.5px solid #f5f5f3" }}>
        <div style={{ display:"flex", gap:"6px", opacity: hovered ? 1 : 0, transition:"opacity 0.15s" }}>
          {isLeaver ? (
            <span style={{ padding:"5px 11px", fontSize:"11px", fontWeight:600, borderRadius:"5px", background:"#f5e8ea", color:"#82162d" }}>Leaver in progress</span>
          ) : (
            <>
              {pending.amend
                ? <a href={`${fsBase}${pending.amend.replace('SR-','')}`} target="_blank" rel="noreferrer" style={pendingStyle}>⏳ {pending.amend} pending</a>
                : <button onClick={() => onAmend(contractor)} style={{ ...btnBase, background:"#f0f0ef", color:"#18073a" }}>Amend date</button>
              }
              {pending.terminate
                ? <a href={`${fsBase}${pending.terminate.replace('SR-','')}`} target="_blank" rel="noreferrer" style={pendingStyle}>⏳ {pending.terminate} pending</a>
                : <button onClick={() => onTerminate(contractor)} style={{ ...btnBase, background:"#f5e8ea", color:"#82162d" }}>Terminate</button>
              }
            </>
          )}
        </div>
      </td>
    </tr>
  );
}

function ContractorTable({ contractors, onAmend, onTerminate, onAmendDetails, pendingRequests }) {
  const thStyle = { textAlign:"left", padding:"10px 16px", fontSize:"9px", fontWeight:700, color:"#b0adc8", textTransform:"uppercase", letterSpacing:"0.08em", borderBottom:"0.5px solid #f0f0ef", background:"#fafaf8", whiteSpace:"nowrap" };
  return (
    <div style={{ background:"#fff", borderRadius:"8px", overflow:"hidden", border:"0.5px solid #e0e0df" }}>
      <table style={{ width:"100%", borderCollapse:"collapse" }}>
        <thead>
          <tr>
            <th style={thStyle}>Name</th>
            <th style={thStyle}>Email</th>
            <th style={thStyle}>Department</th>
            <th style={thStyle}>Job title</th>
            <th style={thStyle}>Contracting Organisation</th>
            <th style={thStyle}></th>
            <th style={thStyle}>Created</th>
            <th style={thStyle}>End date</th>
            <th style={thStyle}>Status</th>
            <th style={thStyle}></th>
          </tr>
        </thead>
        <tbody>
          {contractors.map(c => (
            <ContractorRow key={c.id} contractor={c} onAmend={onAmend} onTerminate={onTerminate} onAmendDetails={onAmendDetails} pendingTicket={pendingRequests[c.email]} isLeaver={c.isLeaver} />
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default ContractorTable;